var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAACNUlEQVRYCe2ZvUoDQRDHc0mlohYWfoFYC34U6gMEH0Ek5E0srMX3COmC+AhJaS+ijWhjJzGIKRKNv4EIQTj29vRmz8uE+btndnIz/1/27hZSKtnLCBgBI2AEjIARMAJKBEajUYTqqINexmoz1lCk1EaYMhisoCaKiwYT5TDdKVTF3BlyxalCK/olcD2L3pAreiTMaHWoudwOMTWHXDFPwj5SCU0ACx6OFj1yf5WqCeDBo1OfXI/TBkzluo7QHXLFbcA2sy2N8yM0RHExYKKabReBz47BE/SKfkaXN4612wuy88LoEkbr6ABJXPOnGUXRC6OFETACRsAIGAEjoEMgyD5ArLEXWGPcQhI37AGe5aDwwvg6ukQf6DvkuMU/AqW4DDC4ip5QXDwysVJYApi7Qq5oFRIArmXpfzK6Qi6HVS0IZa1C1NlBSW660tMuuSohxVQKeRYZeebnP511LzfApJfAcv4dpegQCNN7ExReAJBVML2PwTEEeRrkZiOU5K4sff+5WA2y65u+rfCfk7QTGgEjYASMgBFITSDIPoA9wPT+NIb5XP04mnrppPkg5o/QEMXFgIlqmnPn/jMYi9A9csUtCUEuzUwhYmoPJY3tTJuZOHl54jjrww2PApslpZcmgJ6Hp65H7v9IZe3Pojfkih4JM1qu1FYAP329Y+oCueKc3L4r6V/O881WUBPFRYMJtS8lCEQMyuOwzthB/bHajDVUvMdfEMpW1AgYASNgBIyAEUhC4AtX5mSr/S4FtQAAAABJRU5ErkJggg==",
    id: "img_1"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#img_1",
    fill: "#FFFFFF",
    stroke: "none",
    transform: "scale(0.875 0.875)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuVertical);
export default __webpack_public_path__ + "static/media/icon-menu-vertical.946e230fdca4a1021cf37b9354fb1237.svg";
export { ForwardRef as ReactComponent };